import { Component, OnInit } from '@angular/core';
import { DatabaseResourcesService } from '../../../../services/database-resources/database-resources.service';
import { ResponseDataBase } from '../../../../interfaces/index.interface';
import { AppConstants } from '../../../../appConstants';
import { ResourceService, UserService } from '../../../../services/index.service';
import { Consultant } from '../../../../interfaces/consultant.interface';
import { environment } from "@environments/environment";

@Component({
  selector: 'consultant-page-appointments',
  templateUrl: './appointments.page.html',
  animations: environment.ANIMATIONS
})
export class AppointmentsPage implements OnInit {

  appointmentSlots;
  consultant: Consultant;

  constructor(public _resourceService: ResourceService,
    public _userService: UserService,
    public _databaseResourcesService: DatabaseResourcesService) {
    this.getConsultant(this._userService.user.email);
  }

  getConsultant(email) {
    let params = {
      email: email
    };
    this._databaseResourcesService.getConsultant(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.consultant = response.result[0];
          this.consultant.departments.forEach(department => {
            department.subdepartments.forEach(subdepartment => {
              subdepartment.schedule = subdepartment.schedule[0];
              subdepartment.schedulesDays = [];
              for (var day in subdepartment.schedule) {
                subdepartment.schedule[day] = JSON.parse(subdepartment.schedule[day]);
                subdepartment.schedule[day].name = day;
                subdepartment.schedulesDays.push(subdepartment.schedule[day]);
              }
            })
          });
          let params = {
            consultantId: this.consultant.id
          };
          this.getConsultantAppointments(params);
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        this._resourceService.loading = false;
      });
  }

  getConsultantAppointments(consultantId) {
    this._databaseResourcesService.getConsultantAppointments(consultantId)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.appointmentSlots = response.result;
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        this._resourceService.loading = false;
      });
  }

  ngOnInit() {
  }

}
